import request from '@/utils/request';

/**
 * userContorl.vue
 */

// 用户分页查询列表
export function listUserPage(params) {
  return request({
    url: '/user/listPage',
    method: 'get',
    params,
  });
}

//批量新增用户
export function addUserList(data) {
  return request({
    url: '/user/addList',
    method: 'post',
    data,
  });
}
//新增用户
export function addUserCreate(data) {
  return request({
    url: '/user/create',
    method: 'post',
    data,
    successMessage: 'success',
  });
}

//修改用户
export function updateUser(data) {
  return request({
    url: '/user/update',
    method: 'post',
    data,
    successMessage: 'success',
  });
}

//删除用户
export function delUser(params) {
  return request({
    url: '/user/delete',
    method: 'get',
    params,
  });
}

// 导出用户数据
export function exportListUser(params) {
  return request({
    url: '/user/exportListByRole',
    method: 'get',
    params,
    responseType: 'blob',
  });
}

/**
 * videoContorl.vue
 */

//视频列表
export function listVideoPage(params) {
  return request({
    url: '/video/listPage',
    method: 'get',
    params,
  });
}
//添加视频
export function addVideo(data) {
  return request({
    url: '/video/add',
    method: 'post',
    data,
  });
}
//修改视频
export function updateVideoInfo(data) {
  return request({
    url: '/video/updateInfo',
    method: 'post',
    data,
  });
}

//上传视频图片 返回视频链接
export function updatefile(data) {
  return request({
    url: '/video/upload',
    method: 'post',
    data,
  });
}

/**
 * 学习记录
 * processContorl.vue
 */

export function getStudyProcess(data) {
  return request({
    // url: '/user/getStudyProcess',
    url: '/user/getStudyProcessByRole',
    method: 'post',
    data,
  });
}

export function exportList(data) {
  return request({
    // url: '/video/exportList',
    url: '/video/exportListByRole',
    method: 'post',
    data,
    responseType: 'blob',
  });
}

// export function exportList(params) {
//   return request({
//     url: '/video/exportUserProcessByRole',
//     method: 'get',
//     params,
//     responseType: 'blob',
//   });
// }

/**
 * pagerContorl.vue
 */

// 试卷列表
export function getPagerList(data) {
  return request({
    url: `/exam/paper/list`,
    method: 'post',
    data,
  });
}

export function delPager(data) {
  return request({
    url: `/exam/paper/delete`,
    method: 'DELETE',
    data,
    successMessage: 'success',
  });
}


/**
 * answerContorl
 * 考试记录
 */

export function getAnswerList(data) {
  return request({
    url: `/exam/answer/list`,
    method: 'post',
    data
  });
}

export function exportListAnswer(data) {
  return request({
    url: `/exam/answer/exportList`,
    method: 'post',
    data,
    responseType: 'blob',
  });
}

export function getSettingsPage(data) {
  return request({
    url: `/setting/page`,
    method: 'post',
    data
  });
}

export function delSettings(data) {
  return request({
    url: `/setting/delete`,
    method: 'DELETE',
    data,
    successMessage: 'success',
  });
}

export function addSettings(data) {
  return request({
    url: `/setting/save`,
    method: 'PUT',
    data,
    successMessage: 'success',
  });
}

export function updateSettings(data) {
  return request({
    url: '/setting/update',
    method: 'post',
    data,
    successMessage: 'success',
  });
}

export function getSettings(data) {
  return request({
    url: `/setting/list`,
    method: 'post',
    data
  });
}